<template>
	<ListTile @click="tileClicked" class="my-earning-tile" v-interact>


		<template v-slot:icon>
			<TileIcon v-if="data.earn_option.type !== 'in-house'" :imageName="getOfferOrNetworkIcon(data)"
				:padding="'7px'" :size="42" />
			<TileIcon v-else :imageName="getImage(data.earn_option.name)" :type="'Game'" :padding="'7px'" :size="42" />
		</template>


		<template v-slot:details>
			<div class="d-flex flex-row w-100 align-center my-earning-tile__details">
				<div class="text-body-1 font-weight-bold">{{ data.offer ? data.offer.name : data.earn_option.name }}
				</div>
				<v-spacer></v-spacer>
				<div class="font-weight-medium text-center timestamp" v-if="!isMobileDevice">
					{{ formatDate(data.created_at) }}
				</div>
			</div>
		</template>


		<template v-slot:append-right>
			<CoinChip :coins_amount="data.coins_amount" />
		</template>

	</ListTile>
</template>



<script setup>

import { isMobile } from "@/utils/utils";
import { computed } from "vue";
import { UserActivityStore } from "@/store/UserActivityStore";
import { InHouseTaskMapping } from "@/constants/InHouseTaskMapping";

import CoinChip from "@/components/Common/CoinChip.vue";
import ListTile from '@/components/Tiles/List-Tile.vue';
import TileIcon from "@/components/Common/Tile-Icon.vue";
import { NETWORK_DATA } from "@/constants/Networks/NetworkData";

const emit = defineEmits(['click']);
const props = defineProps({
	earnDataId: {
		type: Number,
		required: true,
	},
});


const isMobileDevice = isMobile();
const inHouseTasksStore = UserActivityStore();


const data = computed(() => inHouseTasksStore.getEarnDataById(props.earnDataId));

const tileClicked = () => {
	inHouseTasksStore.setSelectedEarnData(data.value.id);
	emit('click');
}


// TODO: Move into utils
const formatDate = (timestamp) => {
	const date = new Date(timestamp * 1000);
	const timeFormat = { hour: 'numeric', minute: '2-digit', hour12: true };
	const dateFormat = { month: 'short', day: 'numeric', year: 'numeric' };
	const timeString = date.toLocaleTimeString('en-US', timeFormat);
	const dateString = date.toLocaleDateString('en-US', dateFormat);
	return `${timeString} - ${dateString}`;
};


const getImage = (name) => {
	const image = InHouseTaskMapping[name]?.image ?? "";
	return image;
};

const getOfferOrNetworkIcon = (data) => {
	if (data.offer) {
		return data.offer.icon;
	} else if (data.earn_option && data.earn_option.network_id && NETWORK_DATA[data.earn_option.network_id]) {
		return NETWORK_DATA[data.earn_option.network_id].image;
	} else {
		// Return a default image or empty string if no valid data is found
		return "";
	}
}

</script>